module.exports = __webpack_public_path__ + "img/bake-for-good.e2de11ac.png";